import React, { useEffect, useState } from 'react';
import { Tabs, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { BlueLayout, CustomGoBackButton, PagesContainerUI, TabsContainer } from '../../styles/styled';
import { NmsMemberType } from '../NmsMembers/types';
import NmsEditComponent from './components/NmsEditComponent';
import NmsProfileComponent from './components/NmsProfileComponent';

const { TabPane } = Tabs;

export const NmsMemberPage = () => {
  const { id } = useParams();
  const [currentNmsState, setCurrentNms] = useState<NmsMemberType | null>(null);
  const navigate = useNavigate();

  async function refreshNmsData() {
    if (id) {
      try {
        const currentNmsResponse = await api.get<NmsMemberType>(endpoints.getUserById(id));

        setCurrentNms(currentNmsResponse.data);
      } catch (err) {
        message.error('Ошибка');
      }
    }
  }

  useEffect(() => {
    refreshNmsData();
    //eslint-disable-next-line
  }, []);

  return (
    <PagesContainerUI>
      <BlueLayout padding="25px 0">
        <CustomGoBackButton onClick={() => navigate(-1)}>{'<'}</CustomGoBackButton>
        {currentNmsState?.lastname} {currentNmsState?.firstname} {currentNmsState?.patronymic}{' '}
      </BlueLayout>

      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Профиль" key="1">
            <NmsProfileComponent currentNms={currentNmsState} />
          </TabPane>
          <TabPane tab="Редактирование" key="2">
            <NmsEditComponent currentNms={currentNmsState} handleRefreshNmsData={refreshNmsData} />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
